var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchCompanies(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 526 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3865_49372)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 525.5,
    height: 200,
    rx: 8,
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.5,
    y: 54.5,
    width: 212.026,
    height: 91,
    rx: 15.5,
    stroke: "black",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 64,
    width: 193.026,
    height: 72,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3865_49372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.594 93.1081V110.804H233.837V93.1081V92.4258H234.525H240.678V89.2266H222.734V92.4258H228.906H229.594V93.1081Z",
    fill: "#00304A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.306 107.623H268.795H268.107V106.934V102.306V101.617H268.795H276.503V98.3987H268.795H268.107V97.71V93.0817V92.3929H268.795H279.306V89.168H263.883V110.829H279.306V107.623Z",
    fill: "#00304A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.585 101.431L285.162 89.2266H280.797L292.208 110.553L303.671 89.2266H299.241L292.8 101.431L292.189 102.583L291.585 101.431Z",
    fill: "#00304A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.427 106.934V102.306V101.617H311.115H318.823V98.3987H311.115H310.427V97.71V93.0817V92.3929H311.115H321.62V89.168H306.203V110.829H321.62V107.623H311.115H310.427V106.934Z",
    fill: "#00304A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.521 100.002L335.791 99.6096L343.023 89.2266H338.266L333.708 95.7538L333.142 96.5584L332.583 95.7538L328.031 89.2266H323.28L330.474 99.6096L330.75 100.002L330.474 100.395L323.273 110.791L328.031 110.804L332.576 104.251L333.142 103.44L333.708 104.251L338.272 110.804H343.023L335.791 100.395L335.521 100.002Z",
    fill: "#00304A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.826 102.519C257.318 102.036 257.967 101.624 258.854 100.601C259.928 99.3521 260.449 98.0711 260.449 96.6807V96.082C260.449 93.8291 259.626 92.7348 258.006 91.4023C256.283 89.999 253.846 89.2266 251.153 89.2266H242.75L242.769 110.804H246.993V100.131H246.974V92.4194H250.805C252.387 92.4194 253.872 92.8249 254.689 93.4815H254.701L254.708 93.4943C255.601 94.2668 256.051 95.1809 256.051 96.2237C256.051 98.3865 254.091 100.144 251.686 100.144H249.134V100.131H247.604L248.221 100.91L256.013 110.797H261.111L255.499 103.594L254.894 102.822L255.826 102.519Z",
    fill: "#00304A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.043 107.159H200.43V119.994L218.849 101.552C212.76 100.792 207.251 100.464 202.384 100.406L204.043 107.152V107.159Z",
    fill: "#EAA03D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 98.4551C185.671 99.1181 191.277 99.8455 198.587 99.9743L198.677 99.6138C197.571 98.9958 196.819 97.8114 196.819 96.4532C196.819 94.4577 198.439 92.8355 200.432 92.8355V80",
    fill: "#EAA03D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.428 119.998V107.163H196.815L198.474 100.43C191.441 100.558 185.995 101.247 182.344 101.891L194.199 106.249L200.435 120.005L200.428 119.998Z",
    fill: "#D86748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.043 96.4596C204.043 97.8178 203.297 99.0023 202.185 99.6202L202.275 99.9936C207.264 99.9421 212.928 99.6009 219.202 98.8027L206.659 93.756L200.43 80V92.842C202.423 92.842 204.043 94.4641 204.043 96.4596Z",
    fill: "#D86748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.209 98.8027L200.43 80L206.666 93.756L219.209 98.8027Z",
    fill: "url(#paint0_linear_3865_49372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.209 98.8027L200.43 80L206.666 93.756L219.209 98.8027Z",
    fill: "#E2833D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.199 106.245L182.344 101.887L200.435 120.001L194.199 106.245Z",
    fill: "url(#paint1_linear_3865_49372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.199 106.245L182.344 101.887L200.435 120.001L194.199 106.245Z",
    fill: "#E2833D"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 102,
    r: 139.5,
    stroke: "#DDE5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.5 -88.5C365.988 -88.5 451.5 -3.20902 451.5 102C451.5 207.209 365.988 292.5 260.5 292.5C155.012 292.5 69.5 207.209 69.5 102C69.5 -3.20902 155.012 -88.5 260.5 -88.5Z",
    stroke: "#DDE5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.5 -146.5C397.466 -146.5 508.5 -35.2437 508.5 102C508.5 239.244 397.466 350.5 260.5 350.5C123.534 350.5 12.5 239.244 12.5 102C12.5 -35.2437 123.534 -146.5 260.5 -146.5Z",
    stroke: "#DDE5EA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 102,
    r: 292.5,
    stroke: "#DDE5EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.5,
    y: 10.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#C5CED4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.5,
    y: 10.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3865_49372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.6667 31.5781L97.0083 33.0365C97.6 33.1615 98 33.6615 98 34.2531V42.7531C98 43.4448 97.4417 44.0031 96.75 44.0031H89.25C89.4833 44.0031 89.6667 43.8198 89.6667 43.5865V43.1698H96.75C96.975 43.1698 97.1667 42.9865 97.1667 42.7531V34.2531C97.1667 34.0615 97.0333 33.8865 96.8417 33.8448L89.6667 32.4281V31.5781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2474 35.668C94.4807 35.668 94.6641 35.8513 94.6641 36.0846C94.6641 36.318 94.4807 36.5013 94.2474 36.5013H92.5807C92.3474 36.5013 92.1641 36.318 92.1641 36.0846C92.1641 35.8513 92.3474 35.668 92.5807 35.668H94.2474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2474 38.168C94.4807 38.168 94.6641 38.3513 94.6641 38.5846C94.6641 38.818 94.4807 39.0013 94.2474 39.0013H92.5807C92.3474 39.0013 92.1641 38.818 92.1641 38.5846C92.1641 38.3513 92.3474 38.168 92.5807 38.168H94.2474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2474 40.668C94.4807 40.668 94.6641 40.8513 94.6641 41.0846C94.6641 41.318 94.4807 41.5013 94.2474 41.5013H92.5807C92.3474 41.5013 92.1641 41.318 92.1641 41.0846C92.1641 40.8513 92.3474 40.668 92.5807 40.668H94.2474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6693 43.5871C89.6693 43.8204 89.4859 44.0038 89.2526 44.0038C89.0193 44.0038 88.8359 43.8204 88.8359 43.5871V43.1704V31.9204C88.8359 31.7954 88.8943 31.6788 88.9859 31.5954C89.0859 31.5204 89.2109 31.4871 89.3359 31.5121L89.6693 31.5788V32.4288V43.1704V43.5871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8307 43.168V43.5846C88.8307 43.818 89.0141 44.0013 89.2474 44.0013H85.9141C86.1474 44.0013 86.3307 43.818 86.3307 43.5846V43.168H88.8307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7474 28.168C86.9807 28.168 87.1641 28.3513 87.1641 28.5846C87.1641 28.818 86.9807 29.0013 86.7474 29.0013H85.0807C84.8474 29.0013 84.6641 28.818 84.6641 28.5846C84.6641 28.3513 84.8474 28.168 85.0807 28.168H86.7474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1641 31.0846C87.1641 31.318 86.9807 31.5013 86.7474 31.5013H85.0807C84.8474 31.5013 84.6641 31.318 84.6641 31.0846C84.6641 30.8513 84.8474 30.668 85.0807 30.668H86.7474C86.9807 30.668 87.1641 30.8513 87.1641 31.0846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7474 33.168C86.9807 33.168 87.1641 33.3513 87.1641 33.5846C87.1641 33.818 86.9807 34.0013 86.7474 34.0013H85.0807C84.8474 34.0013 84.6641 33.818 84.6641 33.5846C84.6641 33.3513 84.8474 33.168 85.0807 33.168H86.7474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7474 35.668C86.9807 35.668 87.1641 35.8513 87.1641 36.0846C87.1641 36.318 86.9807 36.5013 86.7474 36.5013H85.0807C84.8474 36.5013 84.6641 36.318 84.6641 36.0846C84.6641 35.8513 84.8474 35.668 85.0807 35.668H86.7474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 36.0846C83 36.318 82.8167 36.5013 82.5833 36.5013H80.9167C80.6833 36.5013 80.5 36.318 80.5 36.0846C80.5 35.8513 80.6833 35.668 80.9167 35.668H82.5833C82.8167 35.668 83 35.8513 83 36.0846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5833 28.168C82.8167 28.168 83 28.3513 83 28.5846C83 28.818 82.8167 29.0013 82.5833 29.0013H80.9167C80.6833 29.0013 80.5 28.818 80.5 28.5846C80.5 28.3513 80.6833 28.168 80.9167 28.168H82.5833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5833 30.668C82.8167 30.668 83 30.8513 83 31.0846C83 31.318 82.8167 31.5013 82.5833 31.5013H80.9167C80.6833 31.5013 80.5 31.318 80.5 31.0846C80.5 30.8513 80.6833 30.668 80.9167 30.668H82.5833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5833 33.168C82.8167 33.168 83 33.3513 83 33.5846C83 33.818 82.8167 34.0013 82.5833 34.0013H80.9167C80.6833 34.0013 80.5 33.818 80.5 33.5846C80.5 33.3513 80.6833 33.168 80.9167 33.168H82.5833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5026 39.418C85.5026 39.1846 85.3109 39.0013 85.0859 39.0013H82.5859C82.3526 39.0013 82.1693 39.1846 82.1693 39.418V43.168H81.3359V39.418C81.3359 38.7263 81.8943 38.168 82.5859 38.168H85.0859C85.7776 38.168 86.3359 38.7263 86.3359 39.418V43.168H85.5026V39.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1693 43.168H85.5026H86.3359V43.5846C86.3359 43.818 86.1526 44.0013 85.9193 44.0013H81.7526C81.5193 44.0013 81.3359 43.818 81.3359 43.5846V43.168H82.1693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4583 24.1686L88.6167 25.5602C89.225 25.6602 89.6667 26.1769 89.6667 26.7936V31.5769L89.3333 31.5102C89.2083 31.4852 89.0833 31.5186 88.9833 31.5936C88.8917 31.6769 88.8333 31.7936 88.8333 31.9186V26.7936C88.8333 26.5852 88.6833 26.4102 88.4833 26.3769L79.325 24.9936C79.3 24.9852 79.275 24.9852 79.25 24.9852C79.15 24.9852 79.0583 25.0186 78.9833 25.0852C78.8833 25.1686 78.8333 25.2769 78.8333 25.4019V42.7519C78.8333 42.9852 79.025 43.1686 79.25 43.1686H81.3333V43.5852C81.3333 43.8186 81.5167 44.0019 81.75 44.0019H79.25C78.5583 44.0019 78 43.4436 78 42.7519V25.4019C78 25.0352 78.1583 24.6852 78.4417 24.4519C78.725 24.2102 79.0917 24.1102 79.4583 24.1686Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 411.5,
    y: 5.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#C5CED4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.5,
    y: 5.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_3865_49372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.667 26.5781L444.008 28.0365C444.6 28.1615 445 28.6615 445 29.2531V37.7531C445 38.4448 444.442 39.0031 443.75 39.0031H436.25C436.483 39.0031 436.667 38.8198 436.667 38.5865V38.1698H443.75C443.975 38.1698 444.167 37.9865 444.167 37.7531V29.2531C444.167 29.0615 444.033 28.8865 443.842 28.8448L436.667 27.4281V26.5781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.247 30.668C441.481 30.668 441.664 30.8513 441.664 31.0846C441.664 31.318 441.481 31.5013 441.247 31.5013H439.581C439.347 31.5013 439.164 31.318 439.164 31.0846C439.164 30.8513 439.347 30.668 439.581 30.668H441.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.247 33.168C441.481 33.168 441.664 33.3513 441.664 33.5846C441.664 33.818 441.481 34.0013 441.247 34.0013H439.581C439.347 34.0013 439.164 33.818 439.164 33.5846C439.164 33.3513 439.347 33.168 439.581 33.168H441.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.247 35.668C441.481 35.668 441.664 35.8513 441.664 36.0846C441.664 36.318 441.481 36.5013 441.247 36.5013H439.581C439.347 36.5013 439.164 36.318 439.164 36.0846C439.164 35.8513 439.347 35.668 439.581 35.668H441.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.669 38.5871C436.669 38.8204 436.486 39.0038 436.253 39.0038C436.019 39.0038 435.836 38.8204 435.836 38.5871V38.1704V26.9204C435.836 26.7954 435.894 26.6788 435.986 26.5954C436.086 26.5204 436.211 26.4871 436.336 26.5121L436.669 26.5788V27.4288V38.1704V38.5871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.831 38.168V38.5846C435.831 38.818 436.014 39.0013 436.247 39.0013H432.914C433.147 39.0013 433.331 38.818 433.331 38.5846V38.168H435.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.747 23.168C433.981 23.168 434.164 23.3513 434.164 23.5846C434.164 23.818 433.981 24.0013 433.747 24.0013H432.081C431.847 24.0013 431.664 23.818 431.664 23.5846C431.664 23.3513 431.847 23.168 432.081 23.168H433.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.164 26.0846C434.164 26.318 433.981 26.5013 433.747 26.5013H432.081C431.847 26.5013 431.664 26.318 431.664 26.0846C431.664 25.8513 431.847 25.668 432.081 25.668H433.747C433.981 25.668 434.164 25.8513 434.164 26.0846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.747 28.168C433.981 28.168 434.164 28.3513 434.164 28.5846C434.164 28.818 433.981 29.0013 433.747 29.0013H432.081C431.847 29.0013 431.664 28.818 431.664 28.5846C431.664 28.3513 431.847 28.168 432.081 28.168H433.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.747 30.668C433.981 30.668 434.164 30.8513 434.164 31.0846C434.164 31.318 433.981 31.5013 433.747 31.5013H432.081C431.847 31.5013 431.664 31.318 431.664 31.0846C431.664 30.8513 431.847 30.668 432.081 30.668H433.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430 31.0846C430 31.318 429.817 31.5013 429.583 31.5013H427.917C427.683 31.5013 427.5 31.318 427.5 31.0846C427.5 30.8513 427.683 30.668 427.917 30.668H429.583C429.817 30.668 430 30.8513 430 31.0846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.583 23.168C429.817 23.168 430 23.3513 430 23.5846C430 23.818 429.817 24.0013 429.583 24.0013H427.917C427.683 24.0013 427.5 23.818 427.5 23.5846C427.5 23.3513 427.683 23.168 427.917 23.168H429.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.583 25.668C429.817 25.668 430 25.8513 430 26.0846C430 26.318 429.817 26.5013 429.583 26.5013H427.917C427.683 26.5013 427.5 26.318 427.5 26.0846C427.5 25.8513 427.683 25.668 427.917 25.668H429.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.583 28.168C429.817 28.168 430 28.3513 430 28.5846C430 28.818 429.817 29.0013 429.583 29.0013H427.917C427.683 29.0013 427.5 28.818 427.5 28.5846C427.5 28.3513 427.683 28.168 427.917 28.168H429.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.503 34.418C432.503 34.1846 432.311 34.0013 432.086 34.0013H429.586C429.353 34.0013 429.169 34.1846 429.169 34.418V38.168H428.336V34.418C428.336 33.7263 428.894 33.168 429.586 33.168H432.086C432.778 33.168 433.336 33.7263 433.336 34.418V38.168H432.503V34.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.169 38.168H432.503H433.336V38.5846C433.336 38.818 433.153 39.0013 432.919 39.0013H428.753C428.519 39.0013 428.336 38.818 428.336 38.5846V38.168H429.169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.458 19.1686L435.617 20.5602C436.225 20.6602 436.667 21.1769 436.667 21.7936V26.5769L436.333 26.5102C436.208 26.4852 436.083 26.5186 435.983 26.5936C435.892 26.6769 435.833 26.7936 435.833 26.9186V21.7936C435.833 21.5852 435.683 21.4102 435.483 21.3769L426.325 19.9936C426.3 19.9852 426.275 19.9852 426.25 19.9852C426.15 19.9852 426.058 20.0186 425.983 20.0852C425.883 20.1686 425.833 20.2769 425.833 20.4019V37.7519C425.833 37.9852 426.025 38.1686 426.25 38.1686H428.333V38.5852C428.333 38.8186 428.517 39.0019 428.75 39.0019H426.25C425.558 39.0019 425 38.4436 425 37.7519V20.4019C425 20.0352 425.158 19.6852 425.442 19.4519C425.725 19.2102 426.092 19.1102 426.458 19.1686Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 105.5,
    y: 120.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#C5CED4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.5,
    y: 120.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_3865_49372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.667 141.578L138.008 143.036C138.6 143.161 139 143.661 139 144.253V152.753C139 153.445 138.442 154.003 137.75 154.003H130.25C130.483 154.003 130.667 153.82 130.667 153.586V153.17H137.75C137.975 153.17 138.167 152.986 138.167 152.753V144.253C138.167 144.061 138.033 143.886 137.842 143.845L130.667 142.428V141.578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.247 145.668C135.481 145.668 135.664 145.851 135.664 146.085C135.664 146.318 135.481 146.501 135.247 146.501H133.581C133.347 146.501 133.164 146.318 133.164 146.085C133.164 145.851 133.347 145.668 133.581 145.668H135.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.247 148.168C135.481 148.168 135.664 148.351 135.664 148.585C135.664 148.818 135.481 149.001 135.247 149.001H133.581C133.347 149.001 133.164 148.818 133.164 148.585C133.164 148.351 133.347 148.168 133.581 148.168H135.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.247 150.668C135.481 150.668 135.664 150.851 135.664 151.085C135.664 151.318 135.481 151.501 135.247 151.501H133.581C133.347 151.501 133.164 151.318 133.164 151.085C133.164 150.851 133.347 150.668 133.581 150.668H135.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.669 153.587C130.669 153.82 130.486 154.004 130.253 154.004C130.019 154.004 129.836 153.82 129.836 153.587V153.17V141.92C129.836 141.795 129.894 141.679 129.986 141.595C130.086 141.52 130.211 141.487 130.336 141.512L130.669 141.579V142.429V153.17V153.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.831 153.168V153.585C129.831 153.818 130.014 154.001 130.247 154.001H126.914C127.147 154.001 127.331 153.818 127.331 153.585V153.168H129.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.747 138.168C127.981 138.168 128.164 138.351 128.164 138.585C128.164 138.818 127.981 139.001 127.747 139.001H126.081C125.847 139.001 125.664 138.818 125.664 138.585C125.664 138.351 125.847 138.168 126.081 138.168H127.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.164 141.085C128.164 141.318 127.981 141.501 127.747 141.501H126.081C125.847 141.501 125.664 141.318 125.664 141.085C125.664 140.851 125.847 140.668 126.081 140.668H127.747C127.981 140.668 128.164 140.851 128.164 141.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.747 143.168C127.981 143.168 128.164 143.351 128.164 143.585C128.164 143.818 127.981 144.001 127.747 144.001H126.081C125.847 144.001 125.664 143.818 125.664 143.585C125.664 143.351 125.847 143.168 126.081 143.168H127.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.747 145.668C127.981 145.668 128.164 145.851 128.164 146.085C128.164 146.318 127.981 146.501 127.747 146.501H126.081C125.847 146.501 125.664 146.318 125.664 146.085C125.664 145.851 125.847 145.668 126.081 145.668H127.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 146.085C124 146.318 123.817 146.501 123.583 146.501H121.917C121.683 146.501 121.5 146.318 121.5 146.085C121.5 145.851 121.683 145.668 121.917 145.668H123.583C123.817 145.668 124 145.851 124 146.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.583 138.168C123.817 138.168 124 138.351 124 138.585C124 138.818 123.817 139.001 123.583 139.001H121.917C121.683 139.001 121.5 138.818 121.5 138.585C121.5 138.351 121.683 138.168 121.917 138.168H123.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.583 140.668C123.817 140.668 124 140.851 124 141.085C124 141.318 123.817 141.501 123.583 141.501H121.917C121.683 141.501 121.5 141.318 121.5 141.085C121.5 140.851 121.683 140.668 121.917 140.668H123.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.583 143.168C123.817 143.168 124 143.351 124 143.585C124 143.818 123.817 144.001 123.583 144.001H121.917C121.683 144.001 121.5 143.818 121.5 143.585C121.5 143.351 121.683 143.168 121.917 143.168H123.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.503 149.418C126.503 149.185 126.311 149.001 126.086 149.001H123.586C123.353 149.001 123.169 149.185 123.169 149.418V153.168H122.336V149.418C122.336 148.726 122.894 148.168 123.586 148.168H126.086C126.778 148.168 127.336 148.726 127.336 149.418V153.168H126.503V149.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.169 153.168H126.503H127.336V153.585C127.336 153.818 127.153 154.001 126.919 154.001H122.753C122.519 154.001 122.336 153.818 122.336 153.585V153.168H123.169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.458 134.169L129.617 135.56C130.225 135.66 130.667 136.177 130.667 136.794V141.577L130.333 141.51C130.208 141.485 130.083 141.519 129.983 141.594C129.892 141.677 129.833 141.794 129.833 141.919V136.794C129.833 136.585 129.683 136.41 129.483 136.377L120.325 134.994C120.3 134.985 120.275 134.985 120.25 134.985C120.15 134.985 120.058 135.019 119.983 135.085C119.883 135.169 119.833 135.277 119.833 135.402V152.752C119.833 152.985 120.025 153.169 120.25 153.169H122.333V153.585C122.333 153.819 122.517 154.002 122.75 154.002H120.25C119.558 154.002 119 153.444 119 152.752V135.402C119 135.035 119.158 134.685 119.442 134.452C119.725 134.21 120.092 134.11 120.458 134.169Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 296.5,
    y: 179.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#C5CED4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.5,
    y: 179.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_3865_49372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.747 197.168C318.981 197.168 319.164 197.351 319.164 197.585C319.164 197.818 318.981 198.001 318.747 198.001H317.081C316.847 198.001 316.664 197.818 316.664 197.585C316.664 197.351 316.847 197.168 317.081 197.168H318.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.164 200.085C319.164 200.318 318.981 200.501 318.747 200.501H317.081C316.847 200.501 316.664 200.318 316.664 200.085C316.664 199.851 316.847 199.668 317.081 199.668H318.747C318.981 199.668 319.164 199.851 319.164 200.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.583 197.168C314.817 197.168 315 197.351 315 197.585C315 197.818 314.817 198.001 314.583 198.001H312.917C312.683 198.001 312.5 197.818 312.5 197.585C312.5 197.351 312.683 197.168 312.917 197.168H314.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.583 199.668C314.817 199.668 315 199.851 315 200.085C315 200.318 314.817 200.501 314.583 200.501H312.917C312.683 200.501 312.5 200.318 312.5 200.085C312.5 199.851 312.683 199.668 312.917 199.668H314.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.458 193.169L320.617 194.56C321.225 194.66 321.667 195.177 321.667 195.794V200.577L321.333 200.51C321.208 200.485 321.083 200.519 320.983 200.594C320.892 200.677 320.833 200.794 320.833 200.919V195.794C320.833 195.585 320.683 195.41 320.483 195.377L311.325 193.994C311.3 193.985 311.275 193.985 311.25 193.985C311.15 193.985 311.058 194.019 310.983 194.085C310.883 194.169 310.833 194.277 310.833 194.402V211.752C310.833 211.985 311.025 212.169 311.25 212.169H313.333V212.585C313.333 212.819 313.517 213.002 313.75 213.002H311.25C310.558 213.002 310 212.444 310 211.752V194.402C310 194.035 310.158 193.685 310.442 193.452C310.725 193.21 311.092 193.11 311.458 193.169Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 241.5,
    y: -29.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#C5CED4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.5,
    y: -29.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_3865_49372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.667 -8.42188L274.008 -6.96354C274.6 -6.83854 275 -6.33854 275 -5.74687V2.75313C275 3.44479 274.442 4.00313 273.75 4.00313H266.25C266.483 4.00313 266.667 3.81979 266.667 3.58646V3.16979H273.75C273.975 3.16979 274.167 2.98646 274.167 2.75313V-5.74687C274.167 -5.93854 274.033 -6.11354 273.842 -6.15521L266.667 -7.57188V-8.42188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.247 0.667969C271.481 0.667969 271.664 0.851302 271.664 1.08464C271.664 1.31797 271.481 1.5013 271.247 1.5013H269.581C269.347 1.5013 269.164 1.31797 269.164 1.08464C269.164 0.851302 269.347 0.667969 269.581 0.667969H271.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.669 3.58712C266.669 3.82045 266.486 4.00378 266.253 4.00378C266.019 4.00378 265.836 3.82045 265.836 3.58712V3.17045V-8.07955C265.836 -8.20455 265.894 -8.32122 265.986 -8.40455C266.086 -8.47955 266.211 -8.51289 266.336 -8.48789L266.669 -8.42122V-7.57122V3.17045V3.58712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.831 3.16797V3.58464C265.831 3.81797 266.014 4.0013 266.247 4.0013H262.914C263.147 4.0013 263.331 3.81797 263.331 3.58464V3.16797H265.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.503 -0.582031C262.503 -0.815365 262.311 -0.998698 262.086 -0.998698H259.586C259.353 -0.998698 259.169 -0.815365 259.169 -0.582031V3.16797H258.336V-0.582031C258.336 -1.2737 258.894 -1.83203 259.586 -1.83203H262.086C262.778 -1.83203 263.336 -1.2737 263.336 -0.582031V3.16797H262.503V-0.582031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.169 3.16797H262.503H263.336V3.58464C263.336 3.81797 263.153 4.0013 262.919 4.0013H258.753C258.519 4.0013 258.336 3.81797 258.336 3.58464V3.16797H259.169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.458 -15.8314L265.617 -14.4398C266.225 -14.3398 266.667 -13.8231 266.667 -13.2064V-8.4231L266.333 -8.48976C266.208 -8.51476 266.083 -8.48143 265.983 -8.40643C265.892 -8.3231 265.833 -8.20643 265.833 -8.08143V-13.2064C265.833 -13.4148 265.683 -13.5898 265.483 -13.6231L256.325 -15.0064C256.3 -15.0148 256.275 -15.0148 256.25 -15.0148C256.15 -15.0148 256.058 -14.9814 255.983 -14.9148C255.883 -14.8314 255.833 -14.7231 255.833 -14.5981V2.7519C255.833 2.98524 256.025 3.16857 256.25 3.16857H258.333V3.58524C258.333 3.81857 258.517 4.0019 258.75 4.0019H256.25C255.558 4.0019 255 3.44357 255 2.7519V-14.5981C255 -14.9648 255.158 -15.3148 255.442 -15.5481C255.725 -15.7898 256.092 -15.8898 256.458 -15.8314Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 468.5,
    y: 132.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#C5CED4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.5,
    y: 132.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_3865_49372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.667 153.578L501.008 155.036C501.6 155.161 502 155.661 502 156.253V164.753C502 165.445 501.442 166.003 500.75 166.003H493.25C493.483 166.003 493.667 165.82 493.667 165.586V165.17H500.75C500.975 165.17 501.167 164.986 501.167 164.753V156.253C501.167 156.061 501.033 155.886 500.842 155.845L493.667 154.428V153.578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.247 157.668C498.481 157.668 498.664 157.851 498.664 158.085C498.664 158.318 498.481 158.501 498.247 158.501H496.581C496.347 158.501 496.164 158.318 496.164 158.085C496.164 157.851 496.347 157.668 496.581 157.668H498.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.247 160.168C498.481 160.168 498.664 160.351 498.664 160.585C498.664 160.818 498.481 161.001 498.247 161.001H496.581C496.347 161.001 496.164 160.818 496.164 160.585C496.164 160.351 496.347 160.168 496.581 160.168H498.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.247 162.668C498.481 162.668 498.664 162.851 498.664 163.085C498.664 163.318 498.481 163.501 498.247 163.501H496.581C496.347 163.501 496.164 163.318 496.164 163.085C496.164 162.851 496.347 162.668 496.581 162.668H498.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.669 165.587C493.669 165.82 493.486 166.004 493.253 166.004C493.019 166.004 492.836 165.82 492.836 165.587V165.17V153.92C492.836 153.795 492.894 153.679 492.986 153.595C493.086 153.52 493.211 153.487 493.336 153.512L493.669 153.579V154.429V165.17V165.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.831 165.168V165.585C492.831 165.818 493.014 166.001 493.247 166.001H489.914C490.147 166.001 490.331 165.818 490.331 165.585V165.168H492.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.747 150.168C490.981 150.168 491.164 150.351 491.164 150.585C491.164 150.818 490.981 151.001 490.747 151.001H489.081C488.847 151.001 488.664 150.818 488.664 150.585C488.664 150.351 488.847 150.168 489.081 150.168H490.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.164 153.085C491.164 153.318 490.981 153.501 490.747 153.501H489.081C488.847 153.501 488.664 153.318 488.664 153.085C488.664 152.851 488.847 152.668 489.081 152.668H490.747C490.981 152.668 491.164 152.851 491.164 153.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.747 155.168C490.981 155.168 491.164 155.351 491.164 155.585C491.164 155.818 490.981 156.001 490.747 156.001H489.081C488.847 156.001 488.664 155.818 488.664 155.585C488.664 155.351 488.847 155.168 489.081 155.168H490.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.747 157.668C490.981 157.668 491.164 157.851 491.164 158.085C491.164 158.318 490.981 158.501 490.747 158.501H489.081C488.847 158.501 488.664 158.318 488.664 158.085C488.664 157.851 488.847 157.668 489.081 157.668H490.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487 158.085C487 158.318 486.817 158.501 486.583 158.501H484.917C484.683 158.501 484.5 158.318 484.5 158.085C484.5 157.851 484.683 157.668 484.917 157.668H486.583C486.817 157.668 487 157.851 487 158.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.583 150.168C486.817 150.168 487 150.351 487 150.585C487 150.818 486.817 151.001 486.583 151.001H484.917C484.683 151.001 484.5 150.818 484.5 150.585C484.5 150.351 484.683 150.168 484.917 150.168H486.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.583 152.668C486.817 152.668 487 152.851 487 153.085C487 153.318 486.817 153.501 486.583 153.501H484.917C484.683 153.501 484.5 153.318 484.5 153.085C484.5 152.851 484.683 152.668 484.917 152.668H486.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.583 155.168C486.817 155.168 487 155.351 487 155.585C487 155.818 486.817 156.001 486.583 156.001H484.917C484.683 156.001 484.5 155.818 484.5 155.585C484.5 155.351 484.683 155.168 484.917 155.168H486.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.503 161.418C489.503 161.185 489.311 161.001 489.086 161.001H486.586C486.353 161.001 486.169 161.185 486.169 161.418V165.168H485.336V161.418C485.336 160.726 485.894 160.168 486.586 160.168H489.086C489.778 160.168 490.336 160.726 490.336 161.418V165.168H489.503V161.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.169 165.168H489.503H490.336V165.585C490.336 165.818 490.153 166.001 489.919 166.001H485.753C485.519 166.001 485.336 165.818 485.336 165.585V165.168H486.169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.458 146.169L492.617 147.56C493.225 147.66 493.667 148.177 493.667 148.794V153.577L493.333 153.51C493.208 153.485 493.083 153.519 492.983 153.594C492.892 153.677 492.833 153.794 492.833 153.919V148.794C492.833 148.585 492.683 148.41 492.483 148.377L483.325 146.994C483.3 146.985 483.275 146.985 483.25 146.985C483.15 146.985 483.058 147.019 482.983 147.085C482.883 147.169 482.833 147.277 482.833 147.402V164.752C482.833 164.985 483.025 165.169 483.25 165.169H485.333V165.585C485.333 165.819 485.517 166.002 485.75 166.002H483.25C482.558 166.002 482 165.444 482 164.752V147.402C482 147.035 482.158 146.685 482.442 146.452C482.725 146.21 483.092 146.11 483.458 146.169Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 97.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#C5CED4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 97.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_3865_49372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 118.578L33.0083 120.036C33.6 120.161 34 120.661 34 121.253V129.753C34 130.445 33.4417 131.003 32.75 131.003H25.25C25.4833 131.003 25.6667 130.82 25.6667 130.586V130.17H32.75C32.975 130.17 33.1667 129.986 33.1667 129.753V121.253C33.1667 121.061 33.0333 120.886 32.8417 120.845L25.6667 119.428V118.578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2474 122.668C30.4807 122.668 30.6641 122.851 30.6641 123.085C30.6641 123.318 30.4807 123.501 30.2474 123.501H28.5807C28.3474 123.501 28.1641 123.318 28.1641 123.085C28.1641 122.851 28.3474 122.668 28.5807 122.668H30.2474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2474 125.168C30.4807 125.168 30.6641 125.351 30.6641 125.585C30.6641 125.818 30.4807 126.001 30.2474 126.001H28.5807C28.3474 126.001 28.1641 125.818 28.1641 125.585C28.1641 125.351 28.3474 125.168 28.5807 125.168H30.2474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2474 127.668C30.4807 127.668 30.6641 127.851 30.6641 128.085C30.6641 128.318 30.4807 128.501 30.2474 128.501H28.5807C28.3474 128.501 28.1641 128.318 28.1641 128.085C28.1641 127.851 28.3474 127.668 28.5807 127.668H30.2474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6693 130.587C25.6693 130.82 25.4859 131.004 25.2526 131.004C25.0193 131.004 24.8359 130.82 24.8359 130.587V130.17V118.92C24.8359 118.795 24.8943 118.679 24.9859 118.595C25.0859 118.52 25.2109 118.487 25.3359 118.512L25.6693 118.579V119.429V130.17V130.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8307 130.168V130.585C24.8307 130.818 25.0141 131.001 25.2474 131.001H21.9141C22.1474 131.001 22.3307 130.818 22.3307 130.585V130.168H24.8307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7474 115.168C22.9807 115.168 23.1641 115.351 23.1641 115.585C23.1641 115.818 22.9807 116.001 22.7474 116.001H21.0807C20.8474 116.001 20.6641 115.818 20.6641 115.585C20.6641 115.351 20.8474 115.168 21.0807 115.168H22.7474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1641 118.085C23.1641 118.318 22.9807 118.501 22.7474 118.501H21.0807C20.8474 118.501 20.6641 118.318 20.6641 118.085C20.6641 117.851 20.8474 117.668 21.0807 117.668H22.7474C22.9807 117.668 23.1641 117.851 23.1641 118.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7474 120.168C22.9807 120.168 23.1641 120.351 23.1641 120.585C23.1641 120.818 22.9807 121.001 22.7474 121.001H21.0807C20.8474 121.001 20.6641 120.818 20.6641 120.585C20.6641 120.351 20.8474 120.168 21.0807 120.168H22.7474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7474 122.668C22.9807 122.668 23.1641 122.851 23.1641 123.085C23.1641 123.318 22.9807 123.501 22.7474 123.501H21.0807C20.8474 123.501 20.6641 123.318 20.6641 123.085C20.6641 122.851 20.8474 122.668 21.0807 122.668H22.7474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 123.085C19 123.318 18.8167 123.501 18.5833 123.501H16.9167C16.6833 123.501 16.5 123.318 16.5 123.085C16.5 122.851 16.6833 122.668 16.9167 122.668H18.5833C18.8167 122.668 19 122.851 19 123.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5833 115.168C18.8167 115.168 19 115.351 19 115.585C19 115.818 18.8167 116.001 18.5833 116.001H16.9167C16.6833 116.001 16.5 115.818 16.5 115.585C16.5 115.351 16.6833 115.168 16.9167 115.168H18.5833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5833 117.668C18.8167 117.668 19 117.851 19 118.085C19 118.318 18.8167 118.501 18.5833 118.501H16.9167C16.6833 118.501 16.5 118.318 16.5 118.085C16.5 117.851 16.6833 117.668 16.9167 117.668H18.5833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5833 120.168C18.8167 120.168 19 120.351 19 120.585C19 120.818 18.8167 121.001 18.5833 121.001H16.9167C16.6833 121.001 16.5 120.818 16.5 120.585C16.5 120.351 16.6833 120.168 16.9167 120.168H18.5833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5026 126.418C21.5026 126.185 21.3109 126.001 21.0859 126.001H18.5859C18.3526 126.001 18.1693 126.185 18.1693 126.418V130.168H17.3359V126.418C17.3359 125.726 17.8943 125.168 18.5859 125.168H21.0859C21.7776 125.168 22.3359 125.726 22.3359 126.418V130.168H21.5026V126.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1693 130.168H21.5026H22.3359V130.585C22.3359 130.818 22.1526 131.001 21.9193 131.001H17.7526C17.5193 131.001 17.3359 130.818 17.3359 130.585V130.168H18.1693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4583 111.169L24.6167 112.56C25.225 112.66 25.6667 113.177 25.6667 113.794V118.577L25.3333 118.51C25.2083 118.485 25.0833 118.519 24.9833 118.594C24.8917 118.677 24.8333 118.794 24.8333 118.919V113.794C24.8333 113.585 24.6833 113.41 24.4833 113.377L15.325 111.994C15.3 111.985 15.275 111.985 15.25 111.985C15.15 111.985 15.0583 112.019 14.9833 112.085C14.8833 112.169 14.8333 112.277 14.8333 112.402V129.752C14.8333 129.985 15.025 130.169 15.25 130.169H17.3333V130.585C17.3333 130.819 17.5167 131.002 17.75 131.002H15.25C14.5583 131.002 14 130.444 14 129.752V112.402C14 112.035 14.1583 111.685 14.4417 111.452C14.725 111.21 15.0917 111.11 15.4583 111.169Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 377.5,
    y: 91.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#C5CED4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.5,
    y: 91.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_3865_49372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.667 112.578L410.008 114.036C410.6 114.161 411 114.661 411 115.253V123.753C411 124.445 410.442 125.003 409.75 125.003H402.25C402.483 125.003 402.667 124.82 402.667 124.586V124.17H409.75C409.975 124.17 410.167 123.986 410.167 123.753V115.253C410.167 115.061 410.033 114.886 409.842 114.845L402.667 113.428V112.578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.247 116.668C407.481 116.668 407.664 116.851 407.664 117.085C407.664 117.318 407.481 117.501 407.247 117.501H405.581C405.347 117.501 405.164 117.318 405.164 117.085C405.164 116.851 405.347 116.668 405.581 116.668H407.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.247 119.168C407.481 119.168 407.664 119.351 407.664 119.585C407.664 119.818 407.481 120.001 407.247 120.001H405.581C405.347 120.001 405.164 119.818 405.164 119.585C405.164 119.351 405.347 119.168 405.581 119.168H407.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.247 121.668C407.481 121.668 407.664 121.851 407.664 122.085C407.664 122.318 407.481 122.501 407.247 122.501H405.581C405.347 122.501 405.164 122.318 405.164 122.085C405.164 121.851 405.347 121.668 405.581 121.668H407.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.669 124.587C402.669 124.82 402.486 125.004 402.253 125.004C402.019 125.004 401.836 124.82 401.836 124.587V124.17V112.92C401.836 112.795 401.894 112.679 401.986 112.595C402.086 112.52 402.211 112.487 402.336 112.512L402.669 112.579V113.429V124.17V124.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.831 124.168V124.585C401.831 124.818 402.014 125.001 402.247 125.001H398.914C399.147 125.001 399.331 124.818 399.331 124.585V124.168H401.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.747 109.168C399.981 109.168 400.164 109.351 400.164 109.585C400.164 109.818 399.981 110.001 399.747 110.001H398.081C397.847 110.001 397.664 109.818 397.664 109.585C397.664 109.351 397.847 109.168 398.081 109.168H399.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.164 112.085C400.164 112.318 399.981 112.501 399.747 112.501H398.081C397.847 112.501 397.664 112.318 397.664 112.085C397.664 111.851 397.847 111.668 398.081 111.668H399.747C399.981 111.668 400.164 111.851 400.164 112.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.747 114.168C399.981 114.168 400.164 114.351 400.164 114.585C400.164 114.818 399.981 115.001 399.747 115.001H398.081C397.847 115.001 397.664 114.818 397.664 114.585C397.664 114.351 397.847 114.168 398.081 114.168H399.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.747 116.668C399.981 116.668 400.164 116.851 400.164 117.085C400.164 117.318 399.981 117.501 399.747 117.501H398.081C397.847 117.501 397.664 117.318 397.664 117.085C397.664 116.851 397.847 116.668 398.081 116.668H399.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396 117.085C396 117.318 395.817 117.501 395.583 117.501H393.917C393.683 117.501 393.5 117.318 393.5 117.085C393.5 116.851 393.683 116.668 393.917 116.668H395.583C395.817 116.668 396 116.851 396 117.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.583 109.168C395.817 109.168 396 109.351 396 109.585C396 109.818 395.817 110.001 395.583 110.001H393.917C393.683 110.001 393.5 109.818 393.5 109.585C393.5 109.351 393.683 109.168 393.917 109.168H395.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.583 111.668C395.817 111.668 396 111.851 396 112.085C396 112.318 395.817 112.501 395.583 112.501H393.917C393.683 112.501 393.5 112.318 393.5 112.085C393.5 111.851 393.683 111.668 393.917 111.668H395.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.583 114.168C395.817 114.168 396 114.351 396 114.585C396 114.818 395.817 115.001 395.583 115.001H393.917C393.683 115.001 393.5 114.818 393.5 114.585C393.5 114.351 393.683 114.168 393.917 114.168H395.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.503 120.418C398.503 120.185 398.311 120.001 398.086 120.001H395.586C395.353 120.001 395.169 120.185 395.169 120.418V124.168H394.336V120.418C394.336 119.726 394.894 119.168 395.586 119.168H398.086C398.778 119.168 399.336 119.726 399.336 120.418V124.168H398.503V120.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.169 124.168H398.503H399.336V124.585C399.336 124.818 399.153 125.001 398.919 125.001H394.753C394.519 125.001 394.336 124.818 394.336 124.585V124.168H395.169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.458 105.169L401.617 106.56C402.225 106.66 402.667 107.177 402.667 107.794V112.577L402.333 112.51C402.208 112.485 402.083 112.519 401.983 112.594C401.892 112.677 401.833 112.794 401.833 112.919V107.794C401.833 107.585 401.683 107.41 401.483 107.377L392.325 105.994C392.3 105.985 392.275 105.985 392.25 105.985C392.15 105.985 392.058 106.019 391.983 106.085C391.883 106.169 391.833 106.277 391.833 106.402V123.752C391.833 123.985 392.025 124.169 392.25 124.169H394.333V124.585C394.333 124.819 394.517 125.002 394.75 125.002H392.25C391.558 125.002 391 124.444 391 123.752V106.402C391 106.035 391.158 105.685 391.442 105.452C391.725 105.21 392.092 105.11 392.458 105.169Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3865_49372",
    x1: 207.148,
    y1: 100.586,
    x2: 209.932,
    y2: 88.9427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2833D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EBA449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3BE53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3865_49372",
    x1: 196.513,
    y1: 101.578,
    x2: 191.27,
    y2: 111.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2833D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EBA449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3BE53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C857"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3865_49372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 525.5,
    height: 200,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3865_49372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 161.026,
    height: 40,
    fill: "white",
    transform: "translate(182 80)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3865_49372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(78 24)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_3865_49372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(425 19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_3865_49372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(119 134)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_3865_49372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(310 193)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_3865_49372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(255 -16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_3865_49372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(482 146)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_3865_49372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(14 111)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_3865_49372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(391 105)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchCompanies);
export default __webpack_public_path__ + "static/media/search-companies.87bc6f3e8aa838641bcb5a37a5fb9e6a.svg";
export { ForwardRef as ReactComponent };